<ng-container *ngIf="!isDegraded; else degraded">
  <div class="home-mode-bar">
    <div class="home-mode-bar__inner">
      <div
        class="home-mode-tabs"
        [class.is-shop]="activeMode === 'shop'"
        role="group"
        [attr.aria-label]="'home.modes.aria_label' | translate"
      >
        <button
          type="button"
          class="home-mode-tab"
          [class.is-active]="activeMode === 'custom'"
          [attr.aria-pressed]="activeMode === 'custom'"
          (click)="setMode('custom')"
        >
          <mat-icon class="home-mode-tab__icon" aria-hidden="true">palette</mat-icon>
          <span>{{ 'home.modes.custom' | translate }}</span>
        </button>

        <button
          type="button"
          class="home-mode-tab"
          [class.is-active]="activeMode === 'shop'"
          [attr.aria-pressed]="activeMode === 'shop'"
          (click)="setMode('shop')"
        >
          <mat-icon class="home-mode-tab__icon" aria-hidden="true">shopping_bag</mat-icon>
          <span>{{ 'home.modes.shop' | translate }}</span>
        </button>

        <a
          class="home-mode-tab home-mode-tab--limited"
          routerLink="/limited"
          [attr.aria-label]="'common.HEADER.LIMITED' | translate"
        >
          <mat-icon class="home-mode-tab__icon" aria-hidden="true">sell</mat-icon>
          <span>{{ 'common.HEADER.LIMITED' | translate }}</span>
        </a>
      </div>

    </div>
  </div>

  <div class="home-container">
    <div
      *ngIf="hasVisitedCustom"
      class="home-flow-panel"
      [hidden]="activeMode !== 'custom'"
    >
      <section class="home-design-studio">
        <app-home-topcategories
          [topCategories]="topCategories"
          [headerKey]="'home.categories.header'"
          [isPersonalize]="true"
        ></app-home-topcategories>

        <app-home-designproducts
          [curated]="true"
          [wishlistIds]="wishlistIds"
          (wishlistChanged)="onWishlistUpdated()"
        ></app-home-designproducts>

        <app-home-designproducts
          [wishlistIds]="wishlistIds"
          (wishlistChanged)="onWishlistUpdated()"
        ></app-home-designproducts>
      </section>

      <app-home-designtemplate></app-home-designtemplate>
      <app-home-carouselslidestep></app-home-carouselslidestep>
    </div>

    <div class="home-flow-panel" [hidden]="activeMode !== 'shop'">
      <app-home-banner></app-home-banner>

      <section class="home-shop-categories">
        <app-home-topcategories
          [topCategories]="shopCategories"
          [headerKey]="'home.shop.categories_header'"
          [isPersonalize]="false"
          [activeCategoryId]="activeShopCategoryId"
        >
        </app-home-topcategories>
      </section>

      <div
        class="popular-products-lazy-container home-featured-products"
        appLazyViewport
        [rootMargin]="'250px'"
        (inViewport)="onShopProductsInViewport()"
      >
        <app-home-popularproducts
          *ngIf="!popularProductsError"
          [popularProduct]="shopProducts"
          [wishlistIds]="wishlistIds"
          [titleKey]="'home.shop.suggested_title'"
          [loading]="shopProductsLoading"
          [emptyMessageKey]="'home.shop.empty_category'"
          [viewAllQueryParams]="shopViewAllQueryParams"
          (wishlistChanged)="onWishlistUpdated()"
        ></app-home-popularproducts>

        <app-section-error
          *ngIf="popularProductsError"
          (retry)="retryShopProducts()"
        ></app-section-error>
      </div>
    </div>
  </div>
</ng-container>

<ng-template #degraded>
  <div class="degraded-container home-container">
    <div class="degraded-content">
      <div class="degraded-icon">⚠️</div>

      <div class="degraded-message">
        <h3 class="degraded-title">{{ 'home.degraded.title' | translate }}</h3>
        <p
          class="degraded-description"
          [innerHTML]="'home.degraded.description' | translate"
        ></p>
      </div>

      <div class="degraded-actions">
        <button class="btn btn-primary" (click)="retry()">
          🔄 {{ 'home.degraded.retry_btn' | translate }}
        </button>
      </div>
    </div>
  </div>
</ng-template>
